import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Banner from "../Components/HeroBanner";
import NavigationBar from "../Components/NavigationBar";
import Footer from "../Components/Footer";
import { useGetAllPosts } from "../Utlis/useFetchData"; // Adjust the import path as needed
import "../CSS/Homepage.css";
import HomeCard from "../Components/HomeCard";
import Loading from '../Components/Loading';
import Error from '../Pages/Error'
const HomePage = () => {
  const { data: blogPosts, error, loading } = useGetAllPosts();

  return (
    <div>
      {loading ? (<Loading />):error ?(<Error />):(<div>
      <HelmetProvider>
        <Helmet>
          <title>BlogWiki - Explore the Latest News and Updates</title>
          <meta
            name="description"
            content="Discover the latest news, articles, and updates on technology, gadgets, and more. BlogWiki is your go-to source for informative content."
          />
        </Helmet>
      </HelmetProvider>
      <div className="NavigationBar">
        <NavigationBar />
      </div>
      <div>
        <Banner />
      </div>
      <div className="HomeMainWrapper">
        {loading ? (
          <p>Loading...</p>
        ) : error ? (
          <div>Error fetching data: {error.message}</div>
        ) : (
          <>
            <HomeCard Postdata={blogPosts} title="Trending" />
            <HomeCard Postdata={blogPosts} title="Latest News" />
            <HomeCard Postdata={blogPosts} title="Latest Tech" />
            <HomeCard Postdata={blogPosts} title="Latest Gadgets" />
            <HomeCard Postdata={blogPosts} title="Latest Business" />
          </>
        )}
      </div>
      <div className="Footer">
        <Footer />
      </div>
    </div>)}
    </div>
  );
};

export default HomePage;
